// extracted by mini-css-extract-plugin
module.exports = {"LeaveTeam":"LeaveTeam_LeaveTeam__IWRNA"};